<template>
  <v-card
    rounded="sm"
    depressed
    elevation="4"
  >
    <v-card-text class="p-2 pb-4 text-black">
      <p>
        <span>Desafio {{ selectedCycle.name }}</span> <br>
        {{ selectedCycle.count_questions }} questões em {{ selectedCycle.challenge_minutes }} minutos    
      </p>
      <v-container
        v-for="(module,key) in challengeModules"
        :key="key"
        fluid
      >
        <v-row>
          <v-col class="p-1">
            <div
              v-if="module.block_id"
              class="small"
            >
              <p
                class="m-0 font-weight-600"
                style="font-size:13px"
              >
                {{ module.block.trail.name }} 
              </p>
              <p class="m-0">
                {{ module.module_name }}
              </p>
            </div>
            <div
              v-else
              class="small"
            >
              <p
                class="m-0 font-weight-600"
                style="font-size:13px"
              >
                {{ module.subject_name }}
              </p>
              <p class="m-0">
                {{ module.module_name }}
              </p>
            </div>
          </v-col>
        </v-row>
        <v-row class="mb-4 justify-content-start border border-deep-dark rounded-sm">
          <v-col
            v-for="(question) in module.questions"
            :key="question.key"
            cols="2"
            class="d-flex justify-content-center"
            :class="{
              'px-1' : isMobile
            }"
          >
            <MarkerComponentItem
              :question="question"
              :active-tab="activeTab"
              @click="$emit('input',question.key)"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import MarkerComponentItem from "./MarkerComponentItem"

import { mapGetters } from "vuex";

export default {
  name: 'MarkerComponent',
  components:{
    MarkerComponentItem,
  },
  props: {
    activeTab: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['challengeModules','challenge','selectedCycle']),
  }
}
</script>


